<template>
  <el-menu router :default-active="thisKeyPath" class="el-menu-vertical-demo" @select="headleSelect" :collapse="isCollapse" :collapse-transition="transition" :class="{'min201':!isCollapse}">
    <template v-for="(item, index) in asideNavList">
      <el-submenu v-if="item.children" :index="item.path" :key="index">
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{item.name}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="(child, cIndex) in item.children" :index="child.path" :key="cIndex">{{child.name}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item v-else :index="item.path" :key="index">
        <i :class="item.icon"></i>
        <span slot="title">{{item.name}}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: 'Aside',
  data () {
    return {
      asideNavList: this.$store.getters.getAsideNavList,
      thisKeyPath: this.$route.path,
      isCollapse: false,
      transition: false
    }
  },
  created () {
    this.routeBindAside(this.$route.path)
    // 初始化检测
    this.openAside()
    // 监听窗口变化
    window.addEventListener('resize', () => {
      this.openAside()
    })
  },
  watch: {
    // 路由切换时定位菜单栏下标
    $route (to, from) {
      this.routeBindAside(to.path)
    }
  },
  methods: {
    // 侧边栏选中
    headleSelect (key, keyPath) {
      this.$store.commit('SET_CURRENTPAGE', 1)
      this.thisKeyPath = key
    },
    // 收起/展开侧边栏
    openAside () {
      if (window.innerWidth <= 1280) {
        if (!this.isCollapse) {
          this.isCollapse = true
        }
      } else {
        if (this.isCollapse) {
          this.isCollapse = false
        }
      }
    },
    // 路由绑定菜单逻辑
    routeBindAside (path) {
      if (path.indexOf('/edit') > -1) {
        this.thisKeyPath = path.replace('/edit', '/list')
      } else if (path.indexOf('/record') > -1) {
        this.thisKeyPath = path.replace('/record', '/list')
      } else {
        this.thisKeyPath = path
      }
    }
  }
}
</script>

<style scoped>
.el-menu{
  height: 100%;
  user-select: none;
}
.min201{
  min-width: 201px;
}
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue